import axios from '@/utils/request'

const queryTotalReserveAmountUrl = '/bill/proof/assets/public/queryTotalReserveAmount'
const queryTotalReserveAmount = async (body = {}) => {
  const data = await axios.post(queryTotalReserveAmountUrl, body)
  return data.data
}

const queryPlatformReserveDetailUrl = '/bill/proof/assets/public/queryPlatformReserveDetail'
const queryPlatformReserveDetail = async (body = {}) => {
  const data = await axios.post(queryPlatformReserveDetailUrl, body)
  return data.data
}

const queryUserAssetsSnapshotByTreeUrl = '/bill/proof/assets/queryNewUserAssetsSnapshotByTree'
const queryUserAssetsSnapshotByTree = async (body = {}) => {
  const data = await axios.post(queryUserAssetsSnapshotByTreeUrl, body)
  return data.data
}

const userNewVerifyUrl = '/bill/proof/assets/userNewVerify'
const userNewVerify = async (body = {}) => {
  const data = await axios.post(userNewVerifyUrl, body)
  return data.data
}

const queryReserveAmountRecordUrl = '/bill/proof/assets/queryReserveAmountRecord'
const queryReserveAmountRecord = async (body = {}) => {
  const data = await axios.post(queryReserveAmountRecordUrl, body)
  return data.data
}

const needLoginUrl = [queryUserAssetsSnapshotByTreeUrl, userNewVerifyUrl]

export default {
  needLoginUrl,
  queryTotalReserveAmount,
  queryPlatformReserveDetail,
  queryUserAssetsSnapshotByTree,
  userNewVerify,
  queryReserveAmountRecord
}
